import { Cell, CellProps } from 'react-aria-components'

import { joinStyles } from 'app/utils/theme'

import * as styles from './index.css'

type TableFooterCellProperties = CellProps & {
    className?: string
}

export const TableFooterCell = ({
    className,
    ...properties
}: Readonly<TableFooterCellProperties>): JSX.Element => {
    return (
        <Cell
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
